export const ENDPOINTS = {
  AUTH_LOGIN: '/auth/user-login',
  GET_ALL_PROJECTS: '/projects',
  GET_SINGLE_PROJECTS: '/projects/single/:id',
  DOWNLOAD_PROJECT_ZIP: '/projects/export-zip/:projectId',
  DOWNLOAD_PROJECT_EXCEL: '/projects/export-excel/:projectId',
  UPDATE_AUTHENTICATED_USER: '/auth/me',
};
